import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Felix ist zehn Jahre alt, geht in die Schule und hat zwei Geschwister. Er spielt gerne mit Lego, Tischfußball, geht gerne ins Kino, mag Comics und die Superhelden, und er geht gerne Klettern und zu den Pfadfindern.'
  },
  {
    type: 'img-full',
    position: 'left',
    imgId: 'das-project-foto-felix3_fk9cg7',
    alt: 'dasProject Foto Felix',
    aspectRatio: 0.666
  },
  {
    type: 'group',
    position: 'right',
    text: 'Was er nicht mag, ist traurig sein. Einen Unterschied zu anderen hat er nicht.',
    firstImg: {
      id: 'das-project-foto-felix4_zcl3av',
      alt: 'dasProject Foto Felix',
      aspectRatio: 1.25
    },
    secondImg: {
      id: 'das-project-foto-felix2_d66foa',
      alt: 'dasProject Foto Felix',
      aspectRatio: 1.25
    }
  },
  {
    type: 'heading',
    text: 'Seine Lebensweisheit: Zuhören und Lachen'
  }
]

const color = 'hotpink'

export default class ReactComponent extends React.Component {
  render () {
    return (
      <div>
        <Person content={content} color={color} name='Felix' next={4} previous={2}/>
      </div>
    )
  }
}

exports.data = {
  color: 'hotpink',
  number: 4
}



// WEBPACK FOOTER //
// ./felix.js